var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{ref:"masterMain",attrs:{"exportProperties":{
    pdf: {
      filename: `${_vm.$t('labor.workers')}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('labor.workers')}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"route":_vm.getModuleRoute,"tableProperties":_vm.tableProperties},on:{"closeModal":_vm.handleCloseModal,"openModal":_vm.handleOpenModal,"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}},[_c('template',{slot:"dialogForm"},[_c('edit-or-create-worker',{ref:"editCreate",attrs:{"syncDialog":_vm.modals},on:{"addEdit":_vm.addEdit,"closeModal":_vm.handleCloseModal,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }